import { AppInstances } from '.';

export const appInstancesThatHaveAccessToCreateContract = [AppInstances.AON_KOMPOSIT];

export const appInstancesThatHaveAccessToCreateCustomer = [AppInstances.AON_KOMPOSIT];
